/**
 * @generated SignedSource<<e36da05f8b4ec186c1b8b8b688ab97ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateClickOutForUserOrBusinessInput = {
  clientMutationId?: string | null;
};
export type navbar_ClickoutMutation$variables = {
  input: CreateClickOutForUserOrBusinessInput;
};
export type navbar_ClickoutMutation$data = {
  readonly Placement: {
    readonly createClickOutForUserOrBusiness: {
      readonly placementUrl: string;
    } | null;
  };
};
export type navbar_ClickoutMutation = {
  response: navbar_ClickoutMutation$data;
  variables: navbar_ClickoutMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PlacementMutations",
    "kind": "LinkedField",
    "name": "Placement",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "CreateClickOutForUserOrBusinessPayload",
        "kind": "LinkedField",
        "name": "createClickOutForUserOrBusiness",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "placementUrl",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "navbar_ClickoutMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "navbar_ClickoutMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8baff0fd3427fec46ae71d7700a1f39a",
    "id": null,
    "metadata": {},
    "name": "navbar_ClickoutMutation",
    "operationKind": "mutation",
    "text": "mutation navbar_ClickoutMutation(\n  $input: CreateClickOutForUserOrBusinessInput!\n) {\n  Placement {\n    createClickOutForUserOrBusiness(input: $input) {\n      placementUrl\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a0a455056b27772bbf024cf6d5be54c3";

export default node;
